import React from 'react';

interface RevisitIconProps {
  className?: string;
  size?: number;
}

export const RevisitIcon: React.FC<RevisitIconProps> = ({ className = '', size = 12 }) => {
  return (
    <svg
      width={size}
      className={className}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M51.3071 45.4303V35.4897L58.1818 35.5139V45.4545L51.3071 45.4303Z" fill="#D95E5E" />
      <path d="M51.3071 35.4897V31.0336L58.1818 31.0578V35.5139L51.3071 35.4897Z" fill="#BE5252" />
      <path d="M51.3071 45.4303V35.4897L26.9308 35.4627L26.9308 45.4029L51.3071 45.4303Z" fill="#F06767" />
      <path d="M18.1818 45.3056L18.1818 35.3653L26.9308 35.4627L26.9308 45.4029L18.1818 45.3056Z" fill="#D95E5E" />
      <path d="M51.3071 35.4897V31.0336L26.9308 31.0066L26.9308 35.4627L51.3071 35.4897Z" fill="#D95E5E" />
      <path d="M18.1818 35.3653L18.1818 30.9091L26.9308 31.0066L26.9308 35.4627L18.1818 35.3653Z" fill="#BE5252" />
      <path
        d="M61.0557 17.5222L64.374 17.5222C66.6398 17.5222 68.4766 19.435 68.4766 21.7945V53.25C68.4766 55.6095 66.6398 57.5222 64.374 57.5222H61.0557C58.7899 57.5222 56.9532 55.6095 56.9532 53.25V21.7945C56.9532 19.435 58.7899 17.5222 61.0557 17.5222Z"
        fill="#F06767"
      />
      <path
        d="M72.5792 21.5222H75.8974C78.1632 21.5222 80 23.435 80 25.7944V49.25C80 51.6095 78.1632 53.5222 75.8974 53.5222H72.5792C70.3134 53.5222 68.4766 51.6095 68.4766 49.25V25.7944C68.4766 23.435 70.3134 21.5222 72.5792 21.5222Z"
        fill="#F29090"
      />
      <path
        d="M18.9443 57.5222H15.626C13.3602 57.5222 11.5234 55.6095 11.5234 53.25L11.5234 21.7945C11.5234 19.435 13.3602 17.5222 15.626 17.5222L18.9443 17.5222C21.2101 17.5222 23.0469 19.435 23.0469 21.7945L23.0469 53.25C23.0469 55.6095 21.2101 57.5222 18.9443 57.5222Z"
        fill="#F06767"
      />
      <path
        d="M7.42085 53.5222H4.10256C1.83678 53.5222 -2.97122e-07 51.6095 0 49.25L2.95366e-06 25.7944C3.25078e-06 23.435 1.83679 21.5222 4.10257 21.5222L7.42085 21.5222C9.68664 21.5222 11.5234 23.435 11.5234 25.7944L11.5234 49.25C11.5234 51.6095 9.68663 53.5222 7.42085 53.5222Z"
        fill="#F29090"
      />
      <path
        d="M4.10261 23.379H7.14586C7.98624 23.379 8.66749 24.0885 8.66749 24.9636C8.66749 25.8387 7.98624 26.5481 7.14586 26.5481H4.10261C3.26223 26.5481 2.58098 25.8387 2.58098 24.9636C2.58098 24.0885 3.26223 23.379 4.10261 23.379Z"
        fill="#F5B7B7"
      />
      <path
        d="M19.2805 20.3008C20.0735 20.3008 20.7188 20.9686 20.7188 21.7945C20.7188 22.6203 20.0735 23.2881 19.2805 23.2881H14.7693C13.9762 23.2881 13.335 22.6203 13.335 21.7945C13.335 20.9686 13.9762 20.3008 14.7693 20.3008H19.2805Z"
        fill="#F29090"
      />
      <path
        d="M64.9578 20.3008C65.7508 20.3008 66.3961 20.9686 66.3961 21.7945C66.3961 22.6203 65.7508 23.2881 64.9578 23.2881H60.4466C59.6535 23.2881 59.0123 22.6203 59.0123 21.7945C59.0123 20.9686 59.6535 20.3008 60.4466 20.3008H64.9578Z"
        fill="#F29090"
      />
      <path
        d="M72.4313 23.379H75.4746C76.3149 23.379 76.9962 24.0885 76.9962 24.9636C76.9962 25.8387 76.3149 26.5481 75.4746 26.5481H72.4313C71.5909 26.5481 70.9097 25.8387 70.9097 24.9636C70.9097 24.0885 71.5909 23.379 72.4313 23.379Z"
        fill="#F5B7B7"
      />
    </svg>
  );
};
